import React from 'react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

import DFSearch from '../components/df-search';
import { DfSearchProvider } from '../context/search/df-search-provider';
import { PAGE_VARIANT } from '../constants';
import ErrorBoundary from '../api/error-boundary';
import { DfCategoriesProvider } from '../context/categories/df-categories-provider';

const client = new QueryClient();
export default function DfSearchModule(): React.ReactElement {
  return (
    <ErrorBoundary slimError={true}>
      <QueryClientProvider client={client}>
        <DfCategoriesProvider>
          <DfSearchProvider>
            <DFSearch variant={PAGE_VARIANT.SEARCH} />
          </DfSearchProvider>
        </DfCategoriesProvider>
      </QueryClientProvider>
    </ErrorBoundary>
  );
}
